import React, { useState } from "react";
import Navbar from "../HomeComponents/Navbar";
import ForgotPasswordSuccess from "./ForgotPasswordSuccess";
import auth from "../../api/auth";
import toast from "react-hot-toast";
import Button from "../GeneralComponents/Button";

function ForgotPassword() {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [step, setStep] = useState(1);

  const regex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

  const onSubmit = async (e) => {
    e.preventDefault();
    if (regex.test(email)) {
      try {
        setLoading(true);
        await auth.resetPassword({ email });
        nextStep();
        setLoading(false);
      } catch (e) {
        setLoading(false);
        toast.error(e?.response?.data?.error || "There was an error");
      }
    } else {
      setError(true);
    }
  };
  const nextStep = () => {
    setStep((step) => step + 1);
  };
  switch (step) {
    default:
      return (
        <div>
          <div>
            <Navbar />
            <div className="bg-[#F3F5F9] lg:mt-[-2rem] border rounded-3xl h-screen lg:mx-auto pb-20 lg:scale-[80%]">
              <h2 className="pt-20 font-semibold text-3xl text-center">
                Forget Password
              </h2>
              <form
                onSubmit={onSubmit}
                className="flex flex-col pt-16 lg:pt-24 justify-center items-center"
              >
                <input
                  required
                  placeholder="Enter Email"
                  type="email"
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  className="w-80 md:w-[450px] outline-pw-blue pl-8 py-2 border-2 rounded-2xl bg-gray-100 mt-8"
                />
                {error && (
                  <div className="text-pw-red pt-3">
                    Enter a valid email address
                  </div>
                )}
                <Button
                  loading={loading}
                  // onClick={handleClick}
                  text={"Reset"}
                  type="submit"
                />
                {/* <button
                  onClick={handleClick}
                  className="mt-12 md:mt-24 py-3 px-24 md:py-[17px] md:px-[180px] bg-pw-blue text-white rounded-3xl hover:bg-cyan-500"
                >
                  Reset
                </button> */}
                <h4 className="mt-8 font-semibold">
                  Don't have an account?{" "}
                  <a href="/signup">
                    <span className="text-pw-blue">Sign up</span>
                  </a>
                </h4>
              </form>
            </div>
          </div>
        </div>
      );
    case 2:
      return <ForgotPasswordSuccess handleClick={() => setStep(1)} />;
  }
}

export default ForgotPassword;
